import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Redirect, withRouter } from "react-router-dom";
import { firebaseApp } from "src/config/firebase";
import {
  buildAuthLinkedUrl,
  getEmbedUid,
  isAuthLinkedPath,
  isInIframe,
} from "src/utils/authLinked";

function getCurrentUid(store) {
  return firebaseApp.auth().currentUser?.uid || store.userFirebase?.uid || null;
}

@withRouter
@inject("store")
@observer
class IframeAuthGuard extends Component {
  needsAuthLinked() {
    const { store, location } = this.props;

    if (!isInIframe()) return false;
    if (isAuthLinkedPath(location.pathname)) return false;
    if (store.authenticating) return false;

    const currentUid = getCurrentUid(store);
    if (store.authenticated && currentUid) {
      const expectedUid = getEmbedUid(location.search);
      if (expectedUid && currentUid !== expectedUid) {
        return true;
      }
      return false;
    }

    return true;
  }

  render() {
    const { children, location } = this.props;

    if (this.needsAuthLinked()) {
      return <Redirect to={buildAuthLinkedUrl(location)} />;
    }

    return children;
  }
}

export default IframeAuthGuard;
